import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fcf3235"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["set"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "p-3 col-12 col-md-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Helpers", -1))
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = {
  key: 1,
  class: "p-3 col-12 col-md-6"
}
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Chords", -1))
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  key: 0,
  class: "p-3 col-12"
}
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Lyrics", -1))
const _hoisted_14 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_SongCategories = _resolveComponent("SongCategories")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.$store.state.mySongs.length > 0 && _ctx.index > -1 && _ctx.$store.state.mySongs[_ctx.index])
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        set: _ctx.song = _ctx.$store.state.mySongs[_ctx.index]
      }, [
        _createVNode(_component_v_card, {
          style: _normalizeStyle({'--song-border-color': _ctx.song.bandColor}),
          elevation: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.song.song), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_subtitle, { class: "d-flex justify-content-start" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.song.band), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_SongCategories, {
                  categoriesUids: _ctx.song.categories
                }, null, 8, ["categoriesUids"]),
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.song.helpers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("pre", _hoisted_5, _toDisplayString(_ctx.replaceInText(_ctx.song.helpers)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.song.chords || _ctx.song.tabUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          (_ctx.song.tabUrl)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                size: "small",
                                color: "secondary",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToUrl(_ctx.song.tabUrl)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("See Tab")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("pre", _hoisted_9, _toDisplayString(_ctx.replaceInText(_ctx.song.chords)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.song.lyrics || _ctx.song.lyricsUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          (_ctx.song.lyricsUrl)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                size: "small",
                                color: "secondary",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToUrl(_ctx.song.lyricsUrl)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("See Lyrics")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("pre", _hoisted_14, _toDisplayString(_ctx.replaceInText(_ctx.song.lyrics)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            (_ctx.navigator.onLine)
              ? (_openBlock(), _createBlock(_component_v_card_actions, {
                  key: 0,
                  class: "d-flex align-items-center justify-content-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "elevated",
                      onClick: _ctx.edit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Edit ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}